import { Pause, Play } from 'lucide-react'

interface StoryPlaybackControlProps {
  isPaused: boolean
  disabled?: boolean
  onToggle: () => void
}

function resolveAriaLabel(isPaused: boolean, disabled: boolean): string {
  if (disabled) return 'Aguarde para continuar'
  if (isPaused) return 'Continuar story'
  return 'Pausar story'
}

export function StoryPlaybackControl({
  isPaused,
  disabled = false,
  onToggle
}: StoryPlaybackControlProps) {
  const showPlayIcon = disabled || isPaused
  const Icon = showPlayIcon ? Play : Pause

  return (
    <button
      type="button"
      disabled={disabled}
      aria-label={resolveAriaLabel(isPaused, disabled)}
      onClick={onToggle}
      className="absolute bottom-4 right-4 z-10 flex min-h-11 min-w-11 items-center justify-center rounded-full bg-black/60 text-white ring-2 ring-white/30 backdrop-blur-sm transition-all duration-100 disabled:cursor-not-allowed disabled:opacity-60"
    >
      <Icon className="h-5 w-5" aria-hidden />
    </button>
  )
}
